import styled from 'styled-components';

const ErrorContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 3rem 1rem;
`;

export default ErrorContainer;
